// extracted by mini-css-extract-plugin
export var numberInputContainer = "_4v-0";
export var startPickingButton = "_4v-1";